import { render, staticRenderFns } from "./HeroHomeSix.vue?vue&type=template&id=1d36c091"
import script from "./HeroHomeSix.vue?vue&type=script&lang=js"
export * from "./HeroHomeSix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports